import {$api} from "../generated/client";

export const useListShippingboHooks = ({ shopId, enabled }: { shopId: string, enabled: boolean }) => {
  return $api.useQuery("get", "/shops/{shopId}/integrations/shippingbo/hooks", {
      params: {path: {shopId}},
    },
    {
      enabled,
    }
  );
};
